import apiClient, { API_ENDPOINTS, dispatchAndResolve, rejectWithError } from "api";
import * as types from "./types.jsx";

const { subscriptionPlan } = API_ENDPOINTS;

export const getAllSubscriptionPlans = (criteria) => async (dispatch) => {
  try {
    const data = await apiClient.post(subscriptionPlan.find, criteria, { skipAuth: true });
    await dispatchAndResolve(dispatch, types.GET_ALL_SUBSCRIPTION_PLANS, data);
    return data?.data || data || [];
  } catch (error) {
    return rejectWithError(error, "Error fetching subscription plans");
  }
};
